import * as React from 'react';

import styles from './metrics.module.css';

export type SecondaryValueType = {
    value: number;
    nounSingular: string;
    nounPlural: string;
    hideValue?: boolean;
};

type Props = {
    secondaryValue: SecondaryValueType;
};

export function SecondaryValue(props: Props) {
    const {value, nounSingular, nounPlural, hideValue} = props.secondaryValue;

    return (
        <span className={styles['stat-secondary-value']}>
            {hideValue ? '' : value.toLocaleString()} {value === 1 ? nounSingular : nounPlural}
        </span>
    );
}
